import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateService } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-bookmark-cell',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './bookmark-cell.component.html',
  styleUrl: './bookmark-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookmarkCellComponent implements ICellRendererAngularComp {

  private readonly translateService = inject(TranslateService); 

  private params!: ICellRendererParams;
  public isBookmarked: boolean = false;
  public tooltip: string = this.translateService.instant('ITEMS.DETAILS.ADD_FAVORITE');

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.updateBookmarkState(params.value);
  }

  toggleBookmark(): void {
    // console.log("toggleBookmark: ",this.isBookmarked, " - params: ", this.params)
    this.isBookmarked = !this.isBookmarked;
    this.updateTooltip();
    this.params.node.setDataValue(this.params?.colDef?.field || '', this.isBookmarked);
  }
  
  private updateBookmarkState(isBookmarked: boolean): void {
    this.isBookmarked = isBookmarked;
    this.updateTooltip();
  }

  private updateTooltip(): void {
    this.tooltip = this.isBookmarked ? this.translateService.instant('ITEMS.DETAILS.REMOVE_FAVORITE') : 
      this.translateService.instant('ITEMS.DETAILS.ADD_FAVORITE');
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.updateBookmarkState(params.value);
    return true;
  }
}